import { render, staticRenderFns } from "./UpdateTask.vue?vue&type=template&id=2827b863"
import script from "./UpdateTask.vue?vue&type=script&lang=js"
export * from "./UpdateTask.vue?vue&type=script&lang=js"
import style0 from "./UpdateTask.vue?vue&type=style&index=0&id=2827b863&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports